import { Menu } from 'lucide-react';
import { Link } from 'react-router';
import { useOrganization } from '../organization/OrganizationProvider';
import { TenantLogo } from '../organization/TenantLogo';

/** Phone header: opens the nav drawer, and keeps the company visible while scrolling. */
export function MobileTopBar({ onOpenNav }: { onOpenNav: () => void }) {
  const { name } = useOrganization();

  return (
    <header className="sticky top-0 z-10 flex h-14 items-center gap-2 border-b border-line bg-surface/85 px-2 backdrop-blur">
      <button
        type="button"
        aria-label="Open navigation"
        onClick={onOpenNav}
        className="grid size-10 place-items-center rounded-md text-muted transition-colors hover:bg-sider-selected hover:text-fg"
      >
        <Menu className="size-5" />
      </button>
      <Link to="/" aria-label={`${name} home`} className="min-w-0">
        <TenantLogo size="yard" />
      </Link>
    </header>
  );
}
